import React, { Suspense, useEffect, useState } from "react";
import LoadingScreen from "../../../components/loader/loading-screen";
import { Container, Row, Col } from "react-bootstrap";
import "../services.css";

import BrandsCarousel from "../../../components/carousels/brands-carousel";
import StepsToHire from "../../../components/steps-to-hire";
import TestimonialCarousel from "../../../components/carousels/testimonial-carousel";
import TestimonialVideoPlayer from "../../../components/videos/testimonial-video";
import ProductPartners from "../../../components/product-partners";
import HeroBanner from "./components/hero";
import BenefitsList from "./components/benefits-list";
import {
    serviceContentConfig,
    serviceUrlRouting,
} from "../../../config/services-config";
import PricingCards from "../../../components/pricing-cards";
import { useLocation } from "react-router-dom";
import ContactForm from "../../../components/forms/contact-form";
import ServicesSection from "./components/services-list";
import SentryVideoTestimonial from "../../../components/videos/sentry-video";

const ServiceBaseLayout = () => {
    const [page, setPage] = useState(null);
    const location = useLocation();
    useEffect(() => {
        const currentPath = window.location.pathname;
        const findPath = serviceUrlRouting.find(
            (data) => data.pathname === currentPath
        );
        const newPage = serviceContentConfig.find(
            (data) => data.pageName === findPath?.pageName
        );

        if (newPage) {
            setPage(newPage);
        }
    }, [location.pathname]);
    if (!page) return null;

    return (
        <Suspense fallback={<LoadingScreen />}>
            <section className="layout-wrapper">
                <HeroBanner
                    title={page.title}
                    content={page.content}
                    backgroundImage={page.backgroundImage}
                    projectCount={page.projectCount}
                />
                <BrandsCarousel />
                <BenefitsList
                    benefits={page.benefitsList?.benefits || []}
                    title={page.benefitsList?.title}
                />
                <ServicesSection
                    alt={page.service.alt}
                    image={page.service.image}
                />
                <PricingCards developer={page.developer} />
                <StepsToHire />
                <TestimonialCarousel />
                <Container>
                    <Row>
                        <Col xs="12" lg="6">
                            <TestimonialVideoPlayer />
                        </Col>
                        <Col xs="12" lg="6">
                            <SentryVideoTestimonial />
                        </Col>
                    </Row>
                </Container>
                <ContactForm />
                <ProductPartners />
            </section>
        </Suspense>
    );
};

export default ServiceBaseLayout;
